import { Injectable } from '@angular/core';
import pkg from '../../../../../../package.json';
import { environment } from '../../../../../components/src/environments/environment';

const TEALIUM_PROFILE = environment.tealium.profile;
const TEALIUM_ENV = environment.tealium.env;
const CDN_URL = environment.dcf_CDN_Url;
const SITE_INDICATOR = 'AAcom';
const APP_ALIAS = 'Flight Status Webcomponent';

declare global {
    interface Window {
        dcf: any;
    }

    interface HTMLElementTagNameMap {
        'dcf-smartweb-service': DataCollectionService;
    }
}

export interface DataCollectionService extends HTMLElement {
    getDataCollectionSchema(): Promise<any>;

    initDataCollectionObj(res: any): any;

    getDataCollectionObj(): Promise<any>;

    updateDataCollectionObj(res: any): any;
}

@Injectable()
export class DataCollectionClientService {
    enableDcfTealium: boolean = true;
    dcfSmartWebService: any;

    constructor() {
        customElements.whenDefined('dcf-smartweb-service').then(() => {
            this.dcfSmartWebService = document.querySelector('dcf-smartweb-service');
        });
    }

    //WITH PROMISE
    async initAnalytics(
        data: any,
        dcfCallType: string,
        tealiumEventType: string
    ) {
        // eslint-disable-next-line no-console


        if (this.dcfSmartWebService === null) {
            await customElements.whenDefined('dcf-smartweb-service');
            this.dcfSmartWebService = document.querySelector('dcf-smartweb-service');
        }

        try {
            Promise.resolve(this.dcfSmartWebService.getDataCollectionSchema()).then(
                (obj) => {
                    if (!this.dcfSmartWebService.isEmpty(obj)) {
                        obj.tealiumeventtype = tealiumEventType;
                        obj.digital.tms.environment = TEALIUM_ENV;
                        obj.digital.tms.profile = TEALIUM_PROFILE;
                        obj.page.pageinfo.name = data.page_name;
                        obj.page.pageinfo.subcategory1 = data.channel;
                        obj.page.pageinfo.primarycategory = SITE_INDICATOR;
                        obj.digital.app.name = pkg.name;
                        obj.digital.app.alias = APP_ALIAS;
                        obj.digital.app.version = pkg.version;
                        this.enableDcfTealium = obj.enabledcftealium;

                        // DCF custom blob mapping
                        this.dcfSmartWebService.customBlobsArray.forEach((item) => {
                            if (Object.keys(data).includes(item)) {
                                obj[item] = data[item];
                            }
                        });

                        this.dcfSmartWebService.initDataCollectionObj(obj);
                    }
                },
                (e) => {
                    // eslint-disable-next-line no-console
                    console.error('Error: initAnalytics() ' + e);
                }
            );
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error accessing getFile():', error);
        }
    }

    async updateAnalytics(
        data: any,
        dcfCallType: string,
        tealiumEventType: string
    ) {
        // eslint-disable-next-line no-console
        console.log('EVENT: ', dcfCallType);

        if (this.dcfSmartWebService === null) {
            await customElements.whenDefined('dcf-smartweb-service');
            this.dcfSmartWebService = document.querySelector('dcf-smartweb-service');
        }

        try {
            customElements.whenDefined('dcf-smartweb-service').then(async () => {
                this.dcfSmartWebService.getDataCollectionObj().subscribe(
                    (obj) => {
                        if (!this.dcfSmartWebService.isEmpty(obj)) {
                            obj.tealiumeventtype = tealiumEventType;
                            obj.page.pageinfo.name = data.page_name;
                            obj.page.pageinfo.subcategory1 = data.channel;
                            obj.page.pageinfo.error = (data.error_id !== undefined) ? data.error_id : '';

                            //DCF custom blob mapping
                            //   this.dcfSmartWebService.customBlobsArray.forEach((item) => {
                            //     if (Object.keys(data).includes(item)) {
                            //       obj[item] = data[item];
                            //     }
                            //   });

                            //app teams can also create a new object under dcfData and append attributes
                            // obj.customObj.attributename = data.customattributeValue;

                            this.dcfSmartWebService.updateDataCollectionObj(obj);
                        }
                    },
                    (error: string) => {
                        // eslint-disable-next-line no-console
                        console.error('Error: updateAnalytics() ' + error);
                    }
                );
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error accessing getFile():', error);
        }
    }

    loadScript(): Promise<void> {
        // embed the custom html element tag for dcf-smartweb-service
        const myCustomElement = document.createElement('dcf-smartweb-service');
        document.body.appendChild(myCustomElement);

        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.crossOrigin = 'anonymous';
            script.src = CDN_URL;
            script.onload = () => resolve();
            script.onerror = (event) => reject(event);
            document.head.appendChild(script);
        });
    }
}
